export default __webpack_public_path__ + "static/media/banner.29721962.jpg";